import { MdChevronRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import PresentationPropertyService from "../../../../Service/PresentationPropertyService";
import { useEffect } from "react";
import { useState } from "react";
import ProspectPropertyService from "../../../../Service/ProspectPropertyService";
import { userUid } from "../../../../../utils/storage";
import ConfirmationModal from "../../../../../components/shareableContainer/ConfirmationModal";
import { showErrorToast } from "../../../../../components/Constant/Notification";
import { ToastContainer } from "react-toastify";

const PresentationPreparationPage = ({ selectedPropertyData , setCurrentStep ,setProgressTrigger }) => {

const [presentationProperty, setPresentationProperty] = useState([]);
const [isConfirmed, setIsConfirmed] = useState(false);

// Function to calculate property completion percentage
const calculatePropertyCompletion = (propertyData) => {
  if (!propertyData) return { percentage: 0, filledCount: 0, totalCount: 0 };

  // Define essential fields that should be filled for a complete property
  const essentialFields = [
    'name',
    'propertyId', 
    'propertyThumbnail',
    'overAllSqft',
    'dtcpNo',
    'guidelineValue',
    'documentType',
    'landmark',
    'roiPercentage',
    'roiYear',
    'reraId',
    'surveyFee',
    'surveyNo',
    'documentCharge',
    'propertyPurchasedDate',
    'underOfGovernance',
    'sro',
    'taluk',
    'geoLocation',
    'address',
    'locationLink',
    'totalProjectWorth',
    'propertySellerName',
    'propertySellerPhoneNumber',
    'propertyVendorName',
    'propertyVendorPhoneNumber',
    'constructionType',
    'ageOfTheProperty',
    'possessionDate',
    'fullyCoveredParkingCharge',
    'semiCoveredParkingCharge',
    'openParkingCharge',
    'driveLink',
    'approvalType'
  ];

  // Array fields that should have at least one item
  const arrayFields = [
    'salesTeam',
    'basicAmenities', 
    'futureAmenities',
    'nearByAmenities',
    'propertyImages',
    'propertyBlueprints',
    'propertyDocuments',
    'propertyFlyers',
    'propertyVideos'
  ];

  let filledCount = 0;
  const totalCount = essentialFields.length + arrayFields.length;

  // Check essential fields
  essentialFields.forEach(field => {
    const value = propertyData[field];
    if (value !== null && value !== undefined && value !== '' && value !== 0) {
      filledCount++;
    }
  });

  // Check array fields
  arrayFields.forEach(field => {
    const value = propertyData[field];
    if (Array.isArray(value) && value.length > 0) {
      filledCount++;
    }
  });

  const percentage = Math.round((filledCount / totalCount) * 100);
  
  return { 
    percentage, 
    filledCount, 
    totalCount,
    remainingCount: totalCount - filledCount 
  };
};

    const navigate = useNavigate();


    const fetchPresantationPropertyById = async (id) => {
        try {
          const response = await PresentationPropertyService.getProspectPropertyIdBasedOnPropertyId(id);
          if (response.status === 200) {
            const data = response.data?.propertyData;
            setPresentationProperty(data);
           
          }
        } catch (error) {
          console.error("Error fetching property by ID:", error);
          setPresentationProperty([]);
        }
      }
      useEffect(() => {
        if (selectedPropertyData?.id){
          fetchPresantationPropertyById(
            selectedPropertyData.id);
        }
      }, [selectedPropertyData]);

      const handleSubmit = () => {
       
      
        if ( !selectedPropertyData?.propertyType?.name) return;
      
        const type = selectedPropertyData?.propertyType?.name;

        const selectedPropertyDetails = {
          id: selectedPropertyData?.propertyType?.id,
          label : selectedPropertyData?.propertyType?.name,
        }
        const selectedSaleName = selectedPropertyData?.propertySaleType?.name;
        const selectedSaleType = selectedPropertyData?.propertySaleType?.id;
      
        if (type === "Layout") {
          navigate(`/presentation-property/layout`, {
            state: {
              selectedPropertyDetails,
              propertySaleType: selectedSaleType,
              selectedSaleName : selectedSaleName,
              prospectPropertyId : selectedPropertyData?.id
            },
          });
          return;
        }
        if(type === "Acres and Cents"){
          navigate(`/presentation-property/acres-and-cents`, {
            state: {
              selectedPropertyDetails,
              propertySaleType: selectedSaleType,
              selectedSaleName : selectedSaleName,
              prospectPropertyId : selectedPropertyData?.id
            },
          });
          return;
        }
        if(type === "Resale Plot"){
          navigate(`/presentation-property/resale-plot`, {
            state: {
              selectedPropertyDetails,
              propertySaleType: selectedSaleType,
              selectedSaleName : selectedSaleName,
              prospectPropertyId : selectedPropertyData?.id
            },
          });
          return;
        }
      
        if (type === "Villa") {
          navigate(`/villa-properties-manage`, {
            state: {
              selectedPropertyDetails,
              propertySaleType: selectedSaleType,
              selectedSaleName : selectedSaleName
            },
          });
          return;
        }
      
        if (type === "Apartment") {
          navigate(`/apartment-properties-manage`, {
            state: {
              selectedPropertyDetails,
              propertySaleType: selectedSaleType,
              selectedSaleName : selectedSaleName
            },
          });
          return;
        }
      
      };

      const handleExitingSubmite = () => {
        if (presentationProperty && presentationProperty.id) {
          const selectedPropertyDetails = {
            id: selectedPropertyData?.propertyType?.id,
            label : selectedPropertyData?.propertyType?.name,
          }
          const selectedSaleName = selectedPropertyData?.propertySaleType?.name;
          const selectedSaleType = selectedPropertyData?.propertySaleType?.id;
            const type = selectedPropertyData?.propertyType?.name;
           
          if (type === "Layout") {
           
            navigate(`/presentation-property/layout`, {
              state: {
                propertyId: presentationProperty?.id,
                propertyInfoStatus : true,
                propertySaleType: presentationProperty?.propertySaleType?.name,
               prospectPropertyId : selectedPropertyData?.id,
               propertyName : presentationProperty?.name,
                propertyTypeId : presentationProperty?.propertyType?.id,
              },
            });
            return;
          }
          if(type === "Acres and Cents"){
            navigate(`/presentation-property/acres-and-cents`, {
              state: {
                propertyId: presentationProperty?.id,
                propertyInfoStatus : true,
                propertySaleType: presentationProperty?.propertySaleType?.name,
               prospectPropertyId : selectedPropertyData?.id,
               propertyName : presentationProperty?.name,
                propertyTypeId : presentationProperty?.propertyType?.id,
              },
            });
            return;
          }
          if(type === "Resale Plot"){
            navigate(`/presentation-property/resale-plot`, {
              state: {
                propertyId: presentationProperty?.id,
                propertyInfoStatus : true,
                propertySaleType: presentationProperty?.propertySaleType?.name,
               prospectPropertyId : selectedPropertyData?.id,
               propertyName : presentationProperty?.name,
                propertyTypeId : presentationProperty?.propertyType?.id,
              },
            });
            return;
          }
        
          if (selectedPropertyData?.propertyType?.name === "Villa") {
            navigate(`/villa-properties-manage`, {
              state: {
                selectedPropertyDetails,
                propertySaleType: selectedSaleType,
                selectedSaleName : selectedSaleName
              },
            });
            return;
          } 
          if (selectedPropertyData?.propertyType?.name === "Apartment") {
            navigate(`/apartment-properties-manage`, {
              state: {
                selectedPropertyDetails,
                propertySaleType: selectedSaleType,
                selectedSaleName : selectedSaleName
              },
            });
            return;
          }
        }
      }

  // Calculate completion statistics
  const propertyToCheck = presentationProperty || selectedPropertyData;
  const completionStats = calculatePropertyCompletion(propertyToCheck);
  const isFullyCompleted = completionStats.percentage === 100;

   const handleMoveToNextStage = async() => {
    if(selectedPropertyData?.propertyType?.name === "Acres and Cents" ){
      showErrorToast("Right now, Acres and Cents property type is not allowed to move to the next stage.");
      return;
    }
    if(selectedPropertyData?.propertyType?.name === "Resale Plot" ){
      showErrorToast("Right now, Resale Plot property type is not allowed to move to the next stage.");
      return;
    }
     await ProspectPropertyService.moveToNextStage({
          propertyId : selectedPropertyData?.id,
          stage : "Confirmed List",
          updatedBy : userUid
        })
        setProgressTrigger((prev) => !prev); 
        setCurrentStep(4)

  }
  
  return (
    <div className="bg-white rounded-[10px] p-6 h-[700px]">
      <ToastContainer/>
      <div className="flex flex-col h-full">
        {/* Header */}
        <div className="flex items-center justify-between  mb-4">
          <h2 className="text-lg font-semibold text-gray-800">
            Presentation Preparing for Confirmed List
          </h2>
          <button
          disabled={completionStats.percentage <= 4}
          onClick={() => {
            setIsConfirmed(true);
          }}
           className={` ${completionStats.percentage > 4 ? 'cursor-pointer text-white bg-customGreen' : 'cursor-default bg-gray-400 text-white'} flex items-center rounded-full px-4 py-2 gap-2 shadow-sm`}
          >
            <span className="text-sm font-medium">Move to Next Stage</span>
            <MdChevronRight className="text-xl" />
          </button>
        </div>

        {/* Content Section */}
        <div className=" w-full max-w-[700px]  items-center justify-center mx-auto my-auto bg-slate-50 border border-slate-200 rounded-lg p-6 flex flex-col   text-center">
         

          {/* Field Count Display */}
          <div className="mb-4 flex items-center gap-36  justify-between">
             <p className="text-gray-600 text-sm ">
            {isFullyCompleted ? 
              "Property details are completely filled." : 
              "Property details are partially filled."
            }
          </p>
            {/* <p className="text-sm text-gray-700 font-medium">
              {completionStats.filledCount} of {completionStats.totalCount} fields completed
            </p> */}
    
          </div>

          {/* Progress Bar */}
          <div className="w-full bg-gray-200 rounded-full h-3 mb-4 overflow-hidden">
            <div
              className={`h-3 rounded-full transition-all duration-500 ${
                isFullyCompleted ? 'bg-green-500' : 'bg-blue-500'
              }`}
              style={{ width: `${completionStats.percentage}%` }} 
            />
          </div>
          <span className="text-xs text-gray-500 mb-4">
            {completionStats.percentage}% Completed
          </span>

          {/* Action Button */}
         <button 
  onClick={() => {
    if (presentationProperty && presentationProperty.id) {

      handleExitingSubmite();
    } else {
      handleSubmit();
    }
  }} 
  className="bg-customGreen text-white px-4 py-2 rounded-lg "
>
  Fill Property Info
</button>

<ConfirmationModal
              title="Confirm Action"
              message={"Are you sure you want to proceed with this action?"}
              showModal={isConfirmed}
              onConfirm={() => {
                handleMoveToNextStage();
                setIsConfirmed(false);
              }}
              onCancel={() => {
                setIsConfirmed(false);
              }}
            />

        </div>
      </div>
    </div>
  );
};

export default PresentationPreparationPage;
